import { createAction, handleActions, combineActions } from 'redux-actions';

// api
import api from '../../utils/api';
import { responseData, responseErrors } from '../../utils/response';

const initialState = {
  authenticated: null,
  user: {
    progress: {},
  },
  isLoading: false,
  errors: null,
};

// const
export const SIGN_IN = 'auth/SIGN_IN';
export const SIGN_UP = 'auth/SIGN_UP';
export const VALIDATE_TOKEN = 'auth/VALIDATE_TOKEN';
export const LOGOUT = 'auth/LOGOUT';
export const DELETE_ACCOUNT = 'auth/DELETE_ACCOUNT';
export const UPDATE_USER = 'auth/UPDATE_USER';
export const DELETE_USER_SUPPORT = 'auth/DELETE_USER_SUPPORT';
export const SET_AUTHENTICATED = 'auth/SET_AUTHENTICATED';
export const PASSWORD_RECOVERY = 'auth/PASSWORD_RECOVERY';
export const PASSWORD_RESET = 'auth/PASSWORD_RESET';
export const UPDATE_PROGRESS = 'auth/UPDATE_PROGRESS';
export const RESET_TIMER = 'auth/RESET_TIMER';
export const SET_SUBSCRIPTION = 'auth/SET_SUBSCRIPTION';

// action creators
export const signInRequest = createAction(SIGN_IN, api.auth.signIn);
export const signUpRequest = createAction(SIGN_UP, api.auth.signUp);
export const logoutRequest = createAction(LOGOUT, api.auth.logout);
export const deleteAccount = createAction(
  DELETE_ACCOUNT,
  api.auth.deleteAccount
);
export const validateToken = createAction(
  VALIDATE_TOKEN,
  api.auth.validateToken
);
export const updateUser = createAction(UPDATE_USER, api.users.update);
export const deleteUserSupport = createAction(
  DELETE_USER_SUPPORT,
  api.users.deleteSupport
);

export const setAuthenticated = createAction(SET_AUTHENTICATED);
export const passwordRecovery = createAction(
  PASSWORD_RECOVERY,
  api.auth.passwordRecovery
);
export const passwordReset = createAction(
  PASSWORD_RESET,
  api.auth.passwordReset
);
export const updateProgress = createAction(UPDATE_PROGRESS, data => ({
  data,
}));
export const resetTimer = createAction(RESET_TIMER, api.auth.resetTimer);
export const setSubscription = createAction(SET_SUBSCRIPTION);

// reducer
const reducer = handleActions(
  {
    /* AUTHENTICATION */
    [combineActions(
      `${SIGN_IN}_REQUEST`,
      `${VALIDATE_TOKEN}_REQUEST`
    )]: state => ({
      ...state,
      isLoading: true,
    }),
    [combineActions(`${SIGN_IN}_SUCCESS`, `${VALIDATE_TOKEN}_SUCCESS`)]: (
      state,
      { payload }
    ) => ({
      ...state,
      isLoading: false,
      authenticated: true,
      user: responseData(payload, 'resource'),
      errors: null,
    }),
    [combineActions(`${SIGN_UP}_SUCCESS`)]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      authenticated: true,
      user: responseData(payload, 'resource'),
      errors: null,
    }),
    [combineActions(`${SIGN_IN}_ERROR`, `${VALIDATE_TOKEN}_ERROR`)]: (
      state,
      { payload }
    ) => ({
      ...state,
      isLoading: false,
      authenticated: false,
      errors: responseErrors(payload),
    }),

    /* SET_AUTHENTICATED */
    [SET_AUTHENTICATED]: (state, { payload }) => ({
      ...state,
      authenticated: payload,
    }),

    [`${LOGOUT}_SUCCESS`]: state => ({
      ...state,
      authenticated: false,
    }),

    /* UPDATE_USER */
    [`${UPDATE_USER}_SUCCESS`]: (state, { payload }) => ({
      ...state,
      user: responseData(payload, 'resource'),
    }),
    [`${UPDATE_USER}_ERROR`]: (state, { payload }) => ({
      ...state,
      errors: responseErrors(payload),
    }),

    /* DELETE_USER_SUPPORT */
    [`${DELETE_USER_SUPPORT}_SUCCESS`]: state => ({
      ...state,
      user: { ...state.user, support_person: null },
    }),
    [`${DELETE_USER_SUPPORT}_ERROR`]: (state, { payload }) => ({
      ...state,
      errors: responseErrors(payload),
    }),

    /* UPDATE_PROGRESS */
    [`${UPDATE_PROGRESS}`]: (state, { payload: { data } }) => {
      return {
        ...state,
        user: {
          ...state.user,
          progress: data,
        },
      };
    },
    [`${RESET_TIMER}_SUCCESS`]: (state, { payload: { resource } }) => {
      return {
        ...state,
        user: {
          ...state.user,
          progress: {
            ...state.user.progress,
            clocks: resource.user_statistic,
          },
        },
      };
    },
    [SET_SUBSCRIPTION]: state => {
      return {
        ...state,
        user: {
          ...state.user,
          progress: {
            ...state.user.progress,
            subscription: true,
          },
        },
      };
    },
  },
  initialState
);

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/auth.js